<div class="row">
    <div class="col-sm-12">
        <table style="width: 100%;">
            <tbody>
                <tr>
                    <td colspan="2">
                        <div class="field-title">Folio</div>
                        <div class="field-value">6745011</div>
                    </td>        
                </tr>
                <tr>
                    <td colspan="2">
                        <div class="field-title">UUID</div>
                        <div class="field-value">E77ADA5E-6712-4B87-BB81-46911C05EF90</div>
                    </td>  
                </tr>
                <tr>
                    <td>
                        <div class="field-title">Fecha de factura</div>
                        <div class="field-value">2024/04/25</div>
                    </td>
                    <td>
                        <div class="field-title">Fecha de carga</div>
                        <div class="field-value">2024/04/10</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div class="field-title">Moneda</div>
                        <div class="field-value">MX</div>
                    </td>       
                    <td>
                        <div class="field-title">Serie</div>
                        <div class="field-value"></div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div class="field-title">Orden de compra</div>
                        <div class="field-value">#1100000054</div>
                    </td>
                    <td>
                        <div class="field-title">Contra recibo</div>
                        <div class="field-value">#1154125</div>
                    </td>  
                </tr>
                <tr>
                    <td>
                        <div class="field-title">Proveedor</div>
                        <div class="field-value">Productos ranchertica SA de CV</div>
                    </td>
                    <td>
                        <div class="field-title">Fecha estimada de pago</div>
                        <div class="field-value">05/25/2024</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div class="field-title">Nota</div>
                        <div class="field-value"></div>
                    </td>
                    <td></td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>
                        <a href="">Descargar XML</a>
                        <br>
                        <a href="">Descargar PDF</a>
                    </td>
                    <td class="d-flex justify-content-end">
                        <table style="width: 200px;">
                            <tr>
                                <td>Sub total</td>
                                <td>$000</td>
                            </tr>
                            <tr>
                                <td>IVA</td>
                                <td>$000</td>
                            </tr>
                            <tr>
                                <td>ISR IVA</td>
                                <td>$000</td>
                            </tr>
                            <tr>
                                <td>ISR RET</td>
                                <td>$000</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>$000</td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>